export default __webpack_public_path__ + "static/media/GR8Conf.8c5a4ec2.svg";